import { Box, Icon, List, type MediumIcon, Text } from '@factorialco/deprecated-design-system'
import {
  PermissionsContextEnum,
  PermissionsRoleTemplatesListFragment,
} from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

interface Props {
  verbs: PermissionsRoleTemplatesListFragment['verbs']
}

function VerbsList({ verbs }: Props) {
  return (
    <Box width="s400">
      <List>
        {verbs.map((verb) => (
          <List.Item key={verb.id}>
            <Box gap="s12">
              <Text size="200" weight="semibold">
                {verb.name}
              </Text>
              <Contexts contexts={verb.grantedContexts} />
            </Box>
          </List.Item>
        ))}
      </List>
    </Box>
  )
}

interface ContextsProps {
  contexts: PermissionsContextEnum[]
}

function Contexts({ contexts }: ContextsProps) {
  const shownContexts: PermissionsContextEnum[] = contexts.includes('everybody')
    ? ['everybody']
    : contexts

  return (
    <Box id="contexts" paddingLeft="s12">
      {shownContexts.map((context) => (
        <Box id="context" key={context} flexDirection="row" gap="s4" alignItems="center">
          <Icon.Medium icon={contextIcon(context)} />
          <Text size="200">{contextLabel(context)}</Text>
        </Box>
      ))}
    </Box>
  )
}

function contextLabel(context: PermissionsContextEnum): string {
  switch (context) {
    case 'owned':
      return i18n.t('settings.permissions.group.contexts.owned')
    case 'reportees':
      return i18n.t('settings.permissions.group.contexts.reportees')
    case 'team_leader':
      return i18n.t('settings.permissions.group.contexts.team_leader')
    case 'everybody':
      return i18n.t('settings.permissions.group.contexts.everybody')
    default:
      throw new TypeError(`Unknown context: ${context}`)
  }
}

function contextIcon(context: PermissionsContextEnum): MediumIcon {
  switch (context) {
    case 'owned':
      return 'person'
    case 'reportees':
      return 'manager'
    case 'team_leader':
      return 'crown'
    default:
      return 'globe'
  }
}

export default VerbsList
